import { Map } from 'immutable';
import * as Actions from '../../actions/coupon/coupon';
import * as MakeBetActions from '../../actions/makeBet';
import * as BetStatus from '../../constants/BetStatus';
import { GET_BET_STATUS, GET_MULTI_BET_STATUS, LIVE_UPDATE_BETSLIPS } from '../../sagas/actions';
import * as BettingState from '../../constants/BettingState';
var initialState = Map();
export default function betSlipsReducer(betSlips, action) {
    switch (action.type) {
        case Actions.ADD_RATE_COUPON:
            return addBetSlip(betSlips, action.data);
        case Actions.CLEAR_BETSLIPS:
            return initialState;
        case Actions.DELETE_BETSLIP:
            return deleteBetSlip(betSlips, action.data);
        // case LIVE_UPDATE.SUCCESS:
        // case LIVE_MATCH_UPDATE.SUCCESS:
        //     return update(betSlips, action.data);
        case LIVE_UPDATE_BETSLIPS.SUCCESS:
            return updateRate(betSlips, action.data);
        case Actions.ACCEPT_FACTOR_CHANGE:
            return acceptRateValueChange(betSlips, action.data);
        case GET_BET_STATUS.SUCCESS:
        case MakeBetActions.SUCCESS_MAKE_BET:
            var status = action.data.State;
            if (status === BetStatus.CONFIRMED) {
                return initialState;
            }
            // if(action.data.Factors && action.data.Factors[0]){
            //     action.data.Factors[0].Value = 0
            // }
            return betCreated(betSlips, action.data);
        case GET_MULTI_BET_STATUS.SUCCESS:
            return betCreated(betSlips, action.data);
        case MakeBetActions.SUCCESS_MAKE_MULTI_SINGLE_BET:
            var data = action.data;
            var failure = data.find(function (f) { return f.State !== BetStatus.CONFIRMED; });
            if (!failure) {
                return initialState;
            }
            else {
                data.map(function (factor) {
                    betSlips = betCreated(betSlips, factor);
                });
                return betSlips;
            }
        default:
            return betSlips;
    }
}
function betCreated(betSlips, createdBet) {
    if (createdBet.Error) {
        switch (createdBet.Error) {
            case -3:
                var factors = createdBet.Factors;
                if (factors) {
                    var rateChange = getRateChange(factors);
                    var rateId = rateChange.factorId;
                    if (rateChange) {
                        if (rateChange.unavailable) {
                            betSlips = betSlips.setIn([rateId, 'unavailable'], true);
                            betSlips = betSlips.setIn([rateId, 'bettingState'], rateChange.bettingState);
                        }
                        if (rateChange.factorChanged) {
                            betSlips = betSlips.setIn([rateId, 'factorChanged'], true);
                            betSlips = betSlips.setIn([rateId, 'rate', 'isBlocked'], true);
                            if (rateChange.value > 0) {
                                betSlips = betSlips.setIn([rateId, 'rate', 'actualValue'], rateChange.value);
                            }
                        }
                    }
                }
                break;
        }
    }
    return betSlips;
}
function getRateChange(factors) {
    var rateChange;
    for (var i = 0; i < factors.length; i++) {
        var factorId = factors[i].FactorId;
        var factorInitialValue = factors[i].InitialValue;
        var factorNewValue = factors[i].Value;
        var bettingState = factors[i].BettingState;
        switch (bettingState) {
            case BettingState.CORRECT:
                if (factorInitialValue !== factorNewValue) {
                    rateChange = {
                        factorId: factorId,
                        value: factorNewValue,
                        factorChanged: true
                    };
                }
                break;
            case BettingState.FACTOR_CHANGED:
                rateChange = {
                    factorId: factorId,
                    value: factorNewValue,
                    factorChanged: true
                };
                break;
            case BettingState.FACTOR_CLOSED:
            case BettingState.OUTCOME_CLOSED:
            case BettingState.EVENT_CLOSED:
                rateChange = {
                    factorId: factorId,
                    unavailable: true,
                    bettingState: bettingState
                };
        }
    }
    return rateChange;
}
function addBetSlip(coupon, addRate) {
    var rate = addRate.get('rate');
    var rateId = rate.get('id');
    if (!coupon.has(rateId)) {
        if (coupon.size === 0) {
            addRate = addRate.set('betNum', 0);
        }
        coupon = coupon.set(rateId, addRate);
        if (addRate.get('amount')) {
            coupon = coupon.deleteIn([rateId, 'amount']);
        }
    }
    return coupon;
}
function deleteBetSlip(coupon, removeRate) {
    return coupon.delete(removeRate);
}
function updateRate(betSlips, data) {
    try {
        betSlips = betSlips.map(function (bs, rateId) {
            if (bs.get('rate').get('isLive')) {
                var _a = (data || []).find(function (_a) {
                    var id = _a.id;
                    return id === rateId;
                }) || {}, v_1 = _a.v, isBlockedByLeague_1 = _a.isBlockedByLeague, isBlockedByOutcome_1 = _a.isBlockedByOutcome;
                if (v_1) {
                    bs = bs.update('rate', function (r) {
                        if (r.get('value') !== v_1) {
                            r = r.update('actualValue', function () { return v_1; });
                            r = r.update('isBlocked', function () { return true; });
                        }
                        r = r.update('isBlockedByLeague', function () { return isBlockedByLeague_1; });
                        r = r.update('isBlockedByOutcome', function () { return isBlockedByOutcome_1; });
                        return r;
                    });
                    bs = bs.update('unavailable', function () { return false; });
                }
                else {
                    bs = bs.update('rate', function (r) {
                        r = r.update('isBlockedByOutcome', function () { return true; });
                        return r;
                    });
                    bs = bs.update('unavailable', function () { return true; });
                }
            }
            return bs;
        });
    }
    catch (error) {
        console.log('Error in betSlipsReducer:updateRate');
    }
    return betSlips;
}
function acceptRateValueChange(betSlips, ratesChanged) {
    var _loop_1 = function (i) {
        var rateChanged = ratesChanged[i];
        betSlips = betSlips.update(rateChanged.id, function (bs) {
            bs = bs.update('rate', function (r) { return r.update('isBlocked', function () { return false; }); });
            bs = bs.deleteIn(['rate', 'actualValue']);
            return bs.update('rate', function (r) { return r.update('value', function () { return rateChanged.actualValue; }); });
        });
    };
    for (var i = 0; i < ratesChanged.length; i++) {
        _loop_1(i);
    }
    return betSlips;
}



// WEBPACK FOOTER //
// ./src/reducers/coupon/betSlipsReducer.js